import advancedFormat from "dayjs/plugin/advancedFormat"
import customParseFormat from "dayjs/plugin/customParseFormat"
import dayjs from "dayjs"

dayjs.extend(advancedFormat)
dayjs.extend(customParseFormat)

const timeFormat = "HH:mm"
const timeInputFormats = [
  "HH:mm:ss",
  "HH:mm",
  "H:mm",
  "h:mm a",
  "h:mma",
  "h a",
  "ha",
]

export function formatDate(date) {
  return date ? date.format("Do MMM YY") : ""
}

export function formatLongDate(dateString) {
  return dateString ? dayjs(dateString).format("dddd D MMMM") : ""
}

export function formatTime(time) {
  if (!time) return ""
  const parsedTime = dayjs(String(time).toLowerCase(), timeInputFormats, true)
  const parsed = parsedTime.isValid() ? parsedTime : dayjs(time)
  return parsed.isValid() ? parsed.format(timeFormat) : ""
}

export function formatTimeRange(startTime, endTime) {
  if (!startTime || !endTime) return ""
  return `${formatTime(startTime)} - ${formatTime(endTime)}`
}

export const dateFormatSlash = "DD/MM/YYYY"

export const slashToDayjs = (date) => dayjs(date, dateFormatSlash, true)
